import { useEffect } from 'react'
import Slick from 'react-slick'

const Slider = ({ children, settings, className, callback }) => {
  useEffect(() => {
    callback && callback()
  }, [])

  return (
    <Slick {...settings} className={className}>
      {children}
    </Slick>
  )
}

export default Slider
